<template>
  <div class="gray-back">
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="row-list" v-for="(order, index) in list" :key="index">
            <div class="justify-space-flex row-title">
              <div class="title-left flex-start gray">
                <img class="row-title-img" src="https://static.dierqudao.com/images/dinghuoxitong/icon-date.png" alt="">
                <span>{{order.create_time | timeFormat}} 申报</span>
              </div>
              <div class="title-right gray">{{order.project}}</div>

            </div>
            <div class="justify-space-flex row-goods"  >
              <div class="row-left flex-start">
                <div class="goods-detail">
                  <div class="goods-name">
                    {{ order.name }} ({{order.grade}})
                    <div>{{order.num}}</div>
                  </div>
                  <div class="goods-weight gray-light">
                    性别:{{order.sex}} 民族:{{order.minzu}}
                  </div>
                </div>
              </div>
<!--              <div class="row-right">-->
<!--                <div class="goods-num gray-light">人数 {{order.members}}</div>-->
<!--              </div>-->
            </div>
            <div class="row-btn">
<!--              <div class="look-order">删除</div>-->
              <div class="look-order" @click="download(order.excel_url)">下载申报表</div>
              <div class="look-order" @click="download(order.file_url)">打包资料</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

      <div class="savebtn">
<!--        <van-button-->
<!--            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--            style="width: 3rem"-->
<!--            size="normal" round @click="showTemplate = true">等级申报-->
<!--        </van-button>-->
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
            @click="addShow=true">新增备案
        </van-button>
      </div>


      <van-popup
          position="bottom"
          :style="{ height: '85%' }"
          v-model="addShow"
          @click-overlay="addShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
            v-show="!idChecked"
              @submit="onIdSubmit"
              @failed="onFailed"
          >
            <van-divider>新增技术等级运动员备案</van-divider>
            <van-cell-group>
              <van-field
                  v-model="formData.name"
                  label="姓名"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入姓名"
              />

              <van-field
                  v-model="formData.num"
                  :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                  error-message-align="right"
                  label="身份证号"
                  input-align="right"
                  clearable
                  placeholder="请输入身份证号"
              />

</van-cell-group>

            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                  native-type="submit">确定
              </van-button>
            </div>
          </van-form>

          <van-form
            v-show="idChecked"
              @submit="onSubmit"
              @failed="onFailed"
          >
            <van-divider>新增技术等级运动员备案</van-divider>
            <van-cell-group>
              <van-field
                  v-model="formData.name"
                  label="姓名"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入姓名"
              />

              <van-field
                  v-model="formData.num"
                  :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                  error-message-align="right"
                  label="身份证号"
                  input-align="right"
                  clearable
                  placeholder="请输入身份证号"
              />

              <van-field
                  v-model="formData.danwei"
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="所属单位"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入单位名称"
              />
              <van-field
                  readonly
                  clickable
                  name="area"
                  :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                  input-align="right"
                  label="所属地区"
                  placeholder="点击选择省市区"
                  @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-area
                    :area-list="areaList"
                    :value="formData.area"
                    @confirm="onAreaConfirm"
                    @cancel="showArea = false"
                />
              </van-popup>


              <van-field
                  name="radio" label="性别"
                  input-align="right">
                <template #input>
                  <van-radio-group v-model="formData.sex" direction="horizontal">
                    <van-radio checked-color="#ffb01b" name="男">男</van-radio>
                    <van-radio checked-color="#ffb01b" name="女">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

              <van-field
                  v-model="formData.minzu"
                  label="民族"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入民族"
              />

              <van-cell title="个人证件照" :value="formData.zhengjianimg.length+'/1'">
              </van-cell>

              <div class="row">
                <PicUploader :fileList="formData.zhengjianimg" :limit="1"
                             :name="'zhengjianimg'"></PicUploader>
              </div>
              <div class="operate-desc-left">近期个人2寸免冠相片</div>

              <van-field
                  v-model="formData.phone"
                  :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                  error-message-align="right"
                  label="手机"
                  input-align="right"
                  clearable
                  placeholder="请输入手机"
              />
              <van-field
                  v-model="formData.email"
                  :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                  error-message-align="right"
                  label="邮箱"
                  input-align="right"
                  clearable
                  placeholder="请输入邮箱"
              />


              <van-field
                  v-model="formData.bisaidate"
                  error-message-align="right"
                  label="通级比赛时间"
                  input-align="right"
                  clearable
                  placeholder="请输入通级比赛时间"
              />

              <van-field
                  v-model="formData.bisaididian"
                  error-message-align="right"
                  label="通级比赛地点"
                  input-align="right"
                  clearable
                  placeholder="请输入通级比赛地点"
              />

              <van-field
                  v-model="formData.bisaichengji"
                  error-message-align="right"
                  label="通级比赛名次"
                  input-align="right"
                  clearable
                  placeholder="请输入通级比赛名次"
              />

              <van-field
                  v-model="formData.chengjidate"
                  error-message-align="right"
                  label="个人能力测试时间"
                  input-align="right"
                  clearable
                  placeholder="请输入个人能力测试时间"
              />

              <van-field
                  v-model="formData.chengjididian"
                  error-message-align="right"
                  label="个人能力测试地点"
                  input-align="right"
                  clearable
                  placeholder="请输入个人能力测试地点"
              />

              <van-field
                  v-model="formData.chengji"
                  error-message-align="right"
                  label="个人能力测试成绩"
                  input-align="right"
                  clearable
                  placeholder="请输入个人能力测试成绩"
              />

              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showOldGradePicker=true"
                  label="已有技术等级"
                  v-model="formData.oldgrade"
              />
              <van-popup v-model="showOldGradePicker" position="bottom">
                <van-picker :columns="oldGradeColumns"
                            show-toolbar
                            @cancel="showOldGradePicker = false"
                            @confirm="onOldGradeConfirm"
                />
              </van-popup>

              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showOldProjectPicker=true"
                  label="已有项目"
                  v-model="formData.oldproject"
              />
              <van-popup v-model="showOldProjectPicker" position="bottom">
                <van-picker :columns="oldProjectColumns"
                            show-toolbar
                            @cancel="showOldProjectPicker = false"
                            @confirm="onOldProjectConfirm"
                />
              </van-popup>

              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showGradePicker=true"
                  label="现报技术等级"
                  v-model="formData.grade"
              />
              <van-popup v-model="showGradePicker" position="bottom">
                <van-picker :columns="gradeColumns"
                            show-toolbar
                            @cancel="showGradePicker = false"
                            @confirm="onGradeConfirm"
                />
              </van-popup>

              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showProjectPicker=true"
                  label="现报项目"
                  v-model="formData.project"
              />
              <van-popup v-model="showProjectPicker" position="bottom">
                <van-picker :columns="projectColumns"
                            show-toolbar
                            @cancel="showProjectPicker = false"
                            @confirm="onProjectConfirm"
                />
              </van-popup>

              <van-field
                  v-model="formData.jianli"
                  label="近三年啦啦操参赛成绩"
                  type="textarea"
                  input-align="right"
                  placeholder="从事啦啦操运动简历和主要运动成绩..."
                  rows="2"
              />

              <van-cell title="身份证照片" :value="formData.pic.length+'/2'">
              </van-cell>
              <div class="row">
                <PicUploader :fileList="formData.pic" :limit="2"
                             :name="'pic'"></PicUploader>
              </div>
              <div class="operate-desc-left">上传身份证正面、背面照片</div>


              <van-cell title="上传相关证明材料" :value="formData.attsrc.length+'/1'">
              </van-cell>
              <div class="row"
              >
                <FileUploader :fileList="formData.attsrc" :limit="1" accept=".rar,.zip"
                              :name="'attsrc'" :uploadText="'上传资料'"></FileUploader>
              </div>
              <div class="operate-desc-left">有效成绩证明，比赛成绩册、秩序册或获奖证书的复印件，请先打包成单个rar或zip格式的文件，然后上传</div>
            </van-cell-group>

            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                  native-type="submit">保存
              </van-button>
            </div>
          </van-form>
        </div>
      </van-popup>

    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}



.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  /*font-size: 12px;*/
  margin-bottom: 0.2rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(253,40,64,1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}
.pay_order{
  width:87px;
  height:26px;
  background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
  border-radius:13px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size:12px;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:26px;
  width:75px;
  height:26px;
  border-radius:13px;
  border:1px solid rgba(0,0,0,1);
  margin-left: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import area from "../../../utils/area";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'LevelApplyMemberList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker,
    PicUploader,
    FileUploader
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      showArea: false,
      showGradePicker: false,
      showProjectPicker: false,
      showOldGradePicker: false,
      showOldProjectPicker: false,
      actionShow: false,
      addShow: false,
      list: [],
      areaList:{},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      oldGradeColumns: ['无', '一星级', '二星级', '三星级', '四星级', '五星级'],
      gradeColumns: ['一星级', '二星级', '三星级', '四星级', '五星级'],
      oldProjectColumns: ['无', '花球啦啦操', '街舞啦啦操', '技巧啦啦操'],
      projectColumns: [ '花球啦啦操', '街舞啦啦操', '技巧啦啦操'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        minzu: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: '男',
        zhengjianimg: [],
        pic: [],
        attsrc: [],
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,
      idChecked: false,

    }
  },
  mounted() {
    document.title = "技术等级运动员备案"
    this.areaList = area;
    this.getList();
  },
  computed: {
  },
  filters: {
    cert(value) {
      switch (value) {
        case 1 :
          return '#ff0000'
          break;
        case 2 :
          return '#FF9966'
          break;
        case 3 :
          return '#FFFF33'
          break;

      }
    }
  },
  destroyed() {
  },
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/yundongyuan/skillApplyMemberList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },


    onAreaConfirm(values) {
      console.log(values);
      this.formData.namekey = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onOldGradeConfirm(value){
      this.formData.oldgrade = value;
      this.showOldGradePicker = false;
    },

    onOldProjectConfirm(value){
      this.formData.oldproject = value;
      this.showOldProjectPicker = false;
    },

    onGradeConfirm(value){
      this.formData.grade = value;
      this.showGradePicker = false;
    },

    onProjectConfirm(value){
      this.formData.project = value;
      this.showProjectPicker = false;
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    // 分享给家长
    onShareParent() {
      let that = this
      appEvent({
        name: 'shareWeixinFriend',
        query: that.share_data
      });
    },

    download(file, name){
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: file
        }
      });
    },


    action(item, index) {
      return
      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
//                console.log(action); return ;
      let that = this;
      switch (index) {
        case 0 :
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          }

          this.actionShow = false;
          break;

        case 1 :
          //认证
          // on confirm
          that.$api.post('/api/yundongyuan/cert', {
            id: that.params.id
          }, (res) => {
            that.onRefresh();
          }, (res) => {
            Toast.fail(res.msg);
          })
          break;

        case 2 :


          break;

      }
      this.actionShow = false;
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (!this.formData.namekey) {
          Toast('请选择所属地区');
          return
        }

        if (!this.formData.grade) {
          Toast('请选择现报技术等级');
          return
        }

        if (!this.formData.project) {
          Toast('请选择现报项目');
          return
        }

        // if (!this.formData.zhengjianimg.length) {
        //   Toast('请上传个人证件照');
        //   return
        // }

        if (!this.formData.pic.length) {
          Toast('请上传身份证照片');
          return
        }

        if (!this.formData.attsrc.length) {
          // Toast('请上传证明材料');
          // return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/skillLevelMemberApply', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          minzu: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: '男',
          zhengjianimg: [],
          pic: [],
          attsrc: [],
        };
        Toast.success('新增成功')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onTongbu(){
      let that = this;
      that.$api.post('/api/yundongyuan/tongbuCca', {}, (res) => {
        Toast(res.msg);
        that.onRefresh();
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },
    onIdSubmit(values){
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);
      let that = this;
      console.log(that.formData)
      that.formValidate = true; 
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/skillLevelMemberChecked', that.formData, (res) => {
        that.saveLoading = false; 
        that.formData = Object.assign(that.formData ,res.data)
        that.idChecked = true;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    }


  }
}
</script>



// WEBPACK FOOTER //
// LevelApplyMemberList.vue?e20014bc